import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import _toConsumableArray from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.array.find";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var ArrayHelper =
/*#__PURE__*/
function () {
  function ArrayHelper() {
    _classCallCheck(this, ArrayHelper);
  }

  _createClass(ArrayHelper, [{
    key: "distinct",
    value: function distinct(field) {
      return function (a, d) {
        if (d && !a.find(function (i) {
          return i && i[field] == d[field];
        })) {
          a.push(d);
        }

        return a;
      };
    }
  }, {
    key: "sortBy",
    value: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };
      reverse = !reverse ? 1 : -1;
      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    }
  }, {
    key: "getDistinctObjectArray",
    value: function getDistinctObjectArray(objects, key) {
      return _toConsumableArray(new Map(objects.map(function (item) {
        return [item[key], item];
      })).values());
    }
  }]);

  return ArrayHelper;
}();

export default new ArrayHelper();